<template>
  <div>
    <v-expansion-panel-header>
      <v-checkbox
        @click.stop="selectedTopicAll"
        :input-value="selected"
        :label="h3"
        style="width: 600px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
      ></v-checkbox>
    </v-expansion-panel-header>
    <v-expansion-panel-content v-if="aList" eager>
      <div v-for="(aValue, aKey) in aList" :key="aKey">
        <ATagCheckBox :name="aValue.name" :url="aValue.url" :tagId="tagId + '_' + aKey" ref="aTagRef" />
      </div>
    </v-expansion-panel-content>
    <v-expansion-panel-content v-if="dir" eager>
      <v-expansion-panels>
        <v-expansion-panel>
          <div v-for="(dirValue, dirKey) in dir" :key="dirKey">
            <DirCheckBox :h3="dirValue.h3" :aList="dirValue.a" :dir="dirValue.dir" :tagId="tagId + '_' + dirKey" ref="dirTagRef" />
          </div>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-expansion-panel-content>
  </div>
</template>
<script>
import ATagCheckBox from '../bookmarks/ATagCheckBox.vue';
export default {
    data () {
      return {
        selected: false
      }
    },
    components: {
      ATagCheckBox
    },
    name: 'DirCheckBox',
    props: [
      'h3',
      'aList',
      'dir',
      'tagId'
    ],
    methods: {
      selectedTopicAll() {
        this.selected = !this.selected;
        // 子コンポーネントのselectedTopicを呼び出して、それぞれをstoreに保存&チェックしている 存在判定行う？
        for (const key in this.$refs.aTagRef) {
          if (this.$refs.aTagRef[key].selected !== this.selected) {
            this.$refs.aTagRef[key].selectedTopic()
          }
        } 
        for (const dirKey in this.$refs.dirTagRef) {
          if (this.$refs.dirTagRef[dirKey].selected !== this.selected) {
            this.$refs.dirTagRef[dirKey].selectedTopicAll()
          }
        }
      }
    }
  }
</script>